/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Docx_TranscriptInputs */

const en_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX Transcript`)
};

const fr_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription DocX`)
};

const de_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX-Transkript`)
};

const it_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione DocX`)
};

const ru_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транскрипт DocX`)
};

const es_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción DocX`)
};

const zh_cn2_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX 文字稿`)
};

const ja_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocXトランスクリプト`)
};

const hi_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX प्रतिलेख`)
};

const pt_pt2_docx_transcript = /** @type {(inputs: Docx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição do DocX`)
};

/**
* | output |
* | --- |
* | "DocX Transcript" |
*
* @param {Docx_TranscriptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const docx_transcript = /** @type {((inputs?: Docx_TranscriptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Docx_TranscriptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_docx_transcript(inputs)
	if (locale === "de") return de_docx_transcript(inputs)
	if (locale === "it") return it_docx_transcript(inputs)
	if (locale === "ru") return ru_docx_transcript(inputs)
	if (locale === "es") return es_docx_transcript(inputs)
	if (locale === "zh-CN") return zh_cn2_docx_transcript(inputs)
	if (locale === "ja") return ja_docx_transcript(inputs)
	if (locale === "hi") return hi_docx_transcript(inputs)
	if (locale === "pt-PT") return pt_pt2_docx_transcript(inputs)
	return en_docx_transcript(inputs)
});